import { CustomCardType } from '../card-slider';
import { BlogNewsListCardData } from '../../blog-news/blog-news';
import { ProductListCardData } from '../../product/product-types';
import { VideoData } from '../../videos/videos-types';
import { SliderCardData } from './slider-card-types';
import { removeTrailingSlash } from '../../../tools/remove-trailing-slash';
import decodeHtmlEntities from '../../../tools/decode-html-entities';
import removeAmpersand from '../../../tools/remove-ampersand';

const VIDEO_POST_TYPE_SLUG = '/video-item/';

/* This is hacky, but it's a temp retro-active fix to allow countries that are using
   this component for pdf downloads */
const customCardTarget = (card: CustomCardType) => {
    if (card?.link?.target) {
        return card.link.target;
    }

    if (card?.link?.url?.includes('wp-content')) {
        return '_blank';
    }

    return '_self';
};

export const mapCustomCardToSliderCard = (card: CustomCardType, onClick?: () => void): SliderCardData => ({
    heading: card?.heading,
    text: card?.text,
    image: card?.image,
    showPlayOverlay: Boolean(onClick),
    href: onClick ? undefined : removeTrailingSlash(card?.link?.url) || undefined,
    target: customCardTarget(card),
    linkTitle: card?.link?.title,
    onClick,
});

export const mapVideoToSliderCard = (video: VideoData, videosEntityName?: string): SliderCardData => {
    const permalink = videosEntityName && video?.permalink
        ? video.permalink.replace(VIDEO_POST_TYPE_SLUG, `/${videosEntityName}/`)
        : video?.permalink;

    return {
        heading: removeAmpersand(video?.video_title?.trim()),
        image: video?.image,
        videoUrl: video?.video_link,
        showPlayOverlay: true,
        href: permalink ? removeTrailingSlash(permalink) : undefined,
        myContent: {
            type: 'video',
            permalink: video?.permalink,
            title: video?.video_title?.trim(),
        },
        isHealthcareProfessional: video?.isHealthcareProfessional,
        isVisibleForPublic: video?.isVisibleForPublic,
    };
};

export const mapProductToSliderCard = (product: ProductListCardData): SliderCardData => {
    const featuredImage = product?.images?.find((image) => image.isFeatured) ?? product?.images?.[0];

    return {
        heading: product?.post_title,
        text: product?.shortDescription,
        image: featuredImage?.file,
        /* Product shots are cut-outs on white — cropping them to the band mangles them. */
        mediaFit: 'contain',
        href: product?.url ? removeTrailingSlash(product.url) : undefined,
        myContent: {
            type: 'product',
            permalink: product?.permalink,
            title: product?.post_title ?? '',
        },
        isHealthcareProfessional: product?.isHealthcareProfessional,
        isVisibleForPublic: product?.isVisibleForPublic,
    };
};

export const mapBlogNewsToSliderCard = (post: BlogNewsListCardData, categoryLabel?: string): SliderCardData => ({
    heading: decodeHtmlEntities(post?.listCardContent?.title),
    text: post?.listCardContent?.cardText,
    image: post?.listCardContent?.image,
    categoryLabel: categoryLabel ?? post?.categories?.[0]?.name,
    href: post?.url ? removeTrailingSlash(post.url) : undefined,
    myContent: {
        type: 'blog-and-news',
        permalink: post?.permalink,
        title: post?.listCardContent?.title ?? '',
    },
    isHealthcareProfessional: post?.isHealthcareProfessional,
    isVisibleForPublic: post?.isVisibleForPublic,
});
